import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Button, Chip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GroupIcon from "@mui/icons-material/Group";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import BusinessIcon from "@mui/icons-material/Business";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api/client";
import dayjs from "dayjs";
import SchoolIcon from "@mui/icons-material/School";
import EditIcon from '@mui/icons-material/Edit';
import { useChangeableItems, getLabelByKey } from "../../store/useDynamicLabel";

const ViewTrainer = () => {

  const changeableItems = useChangeableItems();
  const getLabel = (itemKey) => getLabelByKey(changeableItems, itemKey);

  const location = useLocation();
  const { trainerId } = location?.state || "";
  console.log("trainer", trainerId)
  const [overAllLoading, setOverAllLoading] = useState(false);
  const [trainerData, setTrainerData] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/addTrainer", {
      state: {
        TrainerID: trainerId,
      },
    });
  };

  const fetchById = async () => {
    setOverAllLoading(true);
    try {
      const res = await api.post("ViewTrainerByID", {
        user_id: trainerId,
      });
      if (res?.data?.status === "success") {
        setTrainerData(res?.data?.data);
        setOverAllLoading(false);
      } else {
        setOverAllLoading(false);
      }
    } catch (error) {
      console.error("Error fetching admin by ID:", error);
      setOverAllLoading(false);
    } finally {
      setOverAllLoading(false);
    }
  };

  useEffect(() => {
    fetchById();
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", p: 1 }}>
      {/* Back Button */}
      <Grid
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#1c97e3",
          gap: "4px",
          cursor: "pointer",
          width: "fit-content",
          mb: 2,
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            window.history.back();
          }
        }}
        onClick={() => window.history.back()}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography
          sx={{ fontWeight: 600, fontSize: "14px", color: "#1c97e3" }}
        >
          Back
        </Typography>
      </Grid>

      {/* View Card */}
      <Box>
        {/* Header */}
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #d1d1d1",
          }}
        >
          <Grid
            sx={{
              mb: 2,
              display: "flex",
              gap: 1,
              alignItems: "center",
            }}
          >
            <Grid
              sx={{
                backgroundColor: "#1c97e3",
                p: 0.5,
                borderRadius: "10px",
              }}
            >
              <SchoolIcon sx={{ color: "white", fontSize: "35px" }} />
            </Grid>
            <Grid>
              <Typography sx={{ fontSize: "30px", fontWeight: "bold" }}>
                {getLabel('TRAINER')} Details
              </Typography>
            </Grid>
          </Grid>
          <Grid>
            <Button
              variant="contained"
              className="gradient-button"
              startIcon={<EditIcon />}
              onClick={handleNavigate}
            >
              Edit
            </Button>
          </Grid>
        </Grid>

        {/* Student Details */}
        <Box sx={{ p: 3, display: "flex", flexDirection: "column", rowGap: 3 }}>
          {/* Basic Info */}
          <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <GroupIcon sx={{ color: "#1c97e3", fontSize: "30px" }} />
            <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
              Basic Information
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: 2,
              width: "100%",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                flex: "row",
              }}
            >
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">First Name</Typography>
                <Typography>{trainerData.first_name}</Typography>
              </Grid>
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Last Name</Typography>
                <Typography>{trainerData.last_name}</Typography>
              </Grid>
            </Grid>
            <Grid
              sx={{
                display: "flex",
                flex: "row",
              }}
            >
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Gender</Typography>
                <Typography>{trainerData.gender}</Typography>
              </Grid>
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Date of Birth</Typography>
                <Typography>
                  {dayjs(trainerData.dob).format("DD-MM-YYYY")}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              sx={{
                display: "flex",
                flex: "row",
              }}
            >
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Created By</Typography>
                <Typography>{trainerData.created_by}</Typography>
              </Grid>
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Created Date</Typography>
                <Typography>
                  {dayjs(trainerData.created_at).format("DD-MM-YYYY")}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              sx={{
                display: "flex",
                flex: "row",
              }}
            >
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Updated By</Typography>
                <Typography>{trainerData.updated_by}</Typography>
              </Grid>
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Updated Date</Typography>
                <Typography>
                  {dayjs(trainerData.updated_at).format("DD-MM-YYYY")}
                </Typography>
              </Grid>
            </Grid>

            <Grid
              sx={{
                display: "flex",
                flex: "row",
              }}
            >
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Status</Typography>
                <Typography>{trainerData.status}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Contact Info */}
          <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <MailOutlineIcon sx={{ color: "#1c97e3", fontSize: "30px" }} />
            <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
              Contact Information
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: 2,
            }}
          >
            <Grid sx={{ display: "flex" }}>
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Contact Number</Typography>
                <Typography>{trainerData.phone}</Typography>
              </Grid>
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Email</Typography>
                <Typography>{trainerData.email}</Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Address Info */}
          {/* <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LocationOnIcon sx={{ color: "#1c97e3", fontSize: "30px" }} />
            <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
              Address Information
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: 2,
            }}
          >
            <Grid item xs={12}>
              <Typography fontWeight="600">Address</Typography>
              <Typography>{trainerData.address}</Typography>
            </Grid>
            <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
              <Grid item xs={4}>
                <Typography fontWeight="600">City</Typography>
                <Typography>{trainerData.city}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography fontWeight="600">State</Typography>
                <Typography>{trainerData.state}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography fontWeight="600">Pincode</Typography>
                <Typography>{trainerData.pincode}</Typography>
              </Grid>
            </Grid>
          </Grid> */}
          {/* Institute Info */}
          <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <BusinessIcon sx={{ color: "#1c97e3", fontSize: "30px" }} />
            <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
              {getLabel('INSTITUTE')} Information
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: 2,
            }}
          >
            <Grid sx={{ display: "flex" }}>
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">{getLabel('INSTITUTE')}  Name</Typography>
                <Typography>{trainerData.institute_name}</Typography>
              </Grid>
              <Grid item xs={6} sx={{ width: "50%" }}>
                <Typography fontWeight="600">Assigned {getLabel('PROGRAMS')} </Typography>
                {Array.isArray(trainerData.assigned_programs) &&
                  trainerData.assigned_programs.length ? (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 0.5 }}>
                    {trainerData.assigned_programs.map((p) => (
                      <Chip
                        key={p.program_id}
                        label={p.program_name}
                        size="small"
                        sx={{
                          backgroundColor: "#e3f2fd",
                          color: "#1c97e3",
                          fontWeight: 600,
                        }}
                      />
                    ))}
                  </Box>
                ) : (
                  <Typography>—</Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default ViewTrainer;
